module.exports = __webpack_public_path__ + "img/xsscks-img.c56bcae2.png";